<template lang="pug">
div
  .loading(v-if="loading") Loading&#8230;
  .login-container
    // Fondo animado con gradiente
    .animated-bg
      .gradient-circle.gradient-circle-1
      .gradient-circle.gradient-circle-2
      .gradient-circle.gradient-circle-3

    .login-content
      .login-wrapper
        // Logo con animación
        .logo-container
          img.logo-main(src="@/assets/isotipo-escality.svg" alt="ESCALITY")
          h1.brand-title ESCALITY
          p.brand-subtitle Sistema de Gestión Integral

        // Card de login moderno
        .login-card
          h2.form-title Bienvenido de vuelta
          p.form-subtitle Ingresa tus credenciales para continuar

          form.login-form(@keyup.enter="login" @submit.prevent="login")
            // Email input con icono
            .input-group-modern
              .input-icon
                svg(width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor")
                  path(d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z")
                  polyline(points="22,6 12,13 2,6")
              InputText(
                v-model="credentials.email"
                type="email"
                placeholder="correo@ejemplo.com"
                class="input-modern p-inputtext-lg"
                autocomplete="email"
                required
              )

            // Password input con icono
            .input-group-modern
              .input-icon
                svg(width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor")
                  rect(x="3" y="11" width="18" height="11" rx="2" ry="2")
                  path(d="M7 11V7a5 5 0 0110 0v4")
              Password(
                v-model="credentials.password"
                placeholder="••••••••"
                class="input-modern"
                :feedback="false"
                toggleMask
                autocomplete="current-password"
                required
              )

            // Remember me y forgot password
            .form-options
              .field-checkbox
                Checkbox(inputId="remember" v-model="rememberMe" :binary="true")
                label.remember-check(for="remember") Recordarme
              //- Recuperar contraseña: el link apuntaba a /password/reset, una ruta
              //- que no existe ni en el frontend ni como pantalla usable del backend.
              //- Se retoma cuando se implemente el ingreso por mail (sin contraseña).

            // Botón de login moderno
            Button(
              label="Iniciar Sesión"
              class="btn-login-modern"
              size="large"
              @click="login"
              :loading="loading"
              :disabled="loading"
            )

            // Divider
            .divider
              span o continúa con

            // Social login buttons (futuro)
            .social-buttons
              button.social-btn(disabled)
                svg(width="20" height="20" viewBox="0 0 24 24")
                  path(fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z")
                  path(fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z")
                  path(fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z")
                  path(fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z")
                | Google
              button.social-btn(disabled)
                svg(width="20" height="20" fill="currentColor" viewBox="0 0 24 24")
                  path(d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z")
                | Facebook

          // Link de registro
          .register-link
            | ¿No tienes una cuenta?
            a.link-primary(href="/register") Regístrate gratis

          // Footer info
          .login-footer
            small © {{ year }} ESCALITY · Transformando la gestión empresarial
</template>

<script>
import { useMeStore } from '@/stores/me';
import { useMessagesStore } from '@/stores/messages';
import getApiBaseUrl from '@/utils/apiUrl';

export default {
  components: {
  },
  data: function() {
    return {
      credentials: {
        email: null,
        password: null,
        device: 'escality-app'
      },
      loading: false,
      rememberMe: false
    }
  },
  computed: {
    user() {
      const meStore = useMeStore()
      return meStore.user
    },
    year() {
      return new Date().getFullYear()
    }
  },
  methods: {
    async login() {
      var vm=this;
      vm.loading = true;
      
      try {
        const response = await vm.$http.post(getApiBaseUrl()+'/login', this.credentials);
        
        if(response.data.success && response.data.message=='Success') {
          localStorage.setItem('token', response.data.token);

          // Limpiar expired si existía
          localStorage.removeItem('expired');

          // El login devuelve el mismo estado que /api/users/me y el registro,
          // así que va derecho al store sin transformarlo.
          if (response.data.user) {
            useMeStore().setUser(response.data.user);
          }
          
          // Configurar header de autorización
          vm.$http.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
          
          // Esperar un momento para que el store se actualice
          await vm.$nextTick();
          
          // Usar Vue Router para la navegación
          // Verificar si hay una ruta de redirección pendiente
          const redirectPath = vm.$route.query.redirect || '/';
          
          // Navegar a la ruta deseada
          vm.$router.replace(redirectPath);
        } else {
          // Si la respuesta no es exitosa, desactivar loading
          vm.loading = false;
          const messagesStore = useMessagesStore();
          messagesStore.showError('Respuesta inesperada del servidor');
        }
      } catch(error) {
        vm.loading = false;
        console.error('Login error:', error);
        
        // Mostrar mensaje de error al usuario
        if (error.response) {
          if (error.response.status === 422) {
            // Error de validación
            const errors = error.response.data.errors;
            if (errors) {
              const firstError = Object.values(errors)[0][0];
              const messagesStore = useMessagesStore();
              messagesStore.showError(firstError || 'Datos de acceso inválidos');
            } else {
              const messagesStore = useMessagesStore();
              messagesStore.showError(error.response.data.message || 'Datos de acceso inválidos');
            }
          } else if (error.response.status === 401) {
            const messagesStore = useMessagesStore();
            messagesStore.showError('Credenciales incorrectas');
          } else {
            const messagesStore = useMessagesStore();
            messagesStore.showError('Error al iniciar sesión. Por favor intente nuevamente');
          }
        } else {
          const messagesStore = useMessagesStore();
          messagesStore.showError('Error de conexión. Por favor verifique su conexión a internet');
        }
      }
    }
  }
}
</script>

<style scoped>
/* Contenedor principal */
.login-container {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: var(--escality-gradient-primary);
}

/* Fondo animado */
.animated-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  background: var(--escality-gradient-primary);
}

.gradient-circle {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.3), transparent);
  animation: float 20s infinite ease-in-out;
}

.gradient-circle-1 {
  width: 600px;
  height: 600px;
  top: -200px;
  left: -200px;
  animation-delay: 0s;
}

.gradient-circle-2 {
  width: 800px;
  height: 800px;
  bottom: -300px;
  right: -300px;
  animation-delay: 7s;
}

.gradient-circle-3 {
  width: 400px;
  height: 400px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 14s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.7;
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
    opacity: 1;
  }
}

/* Contenido del login */
.login-content {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}

.login-wrapper {
  width: 100%;
  max-width: 440px;
}

/* Logo container */
.logo-container {
  text-align: center;
  margin-bottom: 2rem;
  animation: fadeInDown 0.8s ease;
}

.logo-main {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.brand-title {
  color: white;
  font-size: 2.5rem;
  font-weight: var(--escality-font-weight-bold);
  margin: 0;
  letter-spacing: -1px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.brand-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: var(--escality-text-md);
  margin-top: 0.5rem;
}

/* Card de login */
.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 2.5rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 0.8s ease;
}

.form-title {
  font-size: var(--escality-text-2xl);
  font-weight: var(--escality-font-weight-bold);
  color: var(--escality-gray-900);
  margin-bottom: 0.5rem;
  text-align: center;
}

.form-subtitle {
  color: var(--escality-gray-500);
  text-align: center;
  margin-bottom: 2rem;
  font-size: var(--escality-text-md);
}

/* Inputs modernos */
.input-group-modern {
  position: relative;
  margin-bottom: 1.5rem;
}

.input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--escality-gray-400);
  z-index: 1;
  display: flex;
  align-items: center;
}

/* Input base styles */
.input-modern.p-inputtext {
  padding-left: 3rem;
  padding-right: 1rem;
  width: 100%;
  height: 50px;
  border: 2px solid var(--escality-gray-200);
  border-radius: var(--escality-radius-lg);
  font-size: var(--escality-text-md);
  transition: all 0.3s ease;
  background: white;
}

.input-modern.p-inputtext:enabled:focus {
  border-color: var(--escality-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  outline: none;
}

.input-modern.p-inputtext::placeholder {
  color: var(--escality-gray-300);
}

/* PrimeVue Password component */
.input-group-modern :deep(.p-password) {
  width: 100%;
}

.input-group-modern :deep(.p-password .p-inputtext) {
  padding-left: 3rem;
  height: 50px;
  border: 2px solid var(--escality-gray-200);
  border-radius: var(--escality-radius-lg);
  font-size: var(--escality-text-md);
  transition: all 0.3s ease;
  background: white;
  width: 100%;
}

.input-group-modern :deep(.p-password .p-inputtext:enabled:focus) {
  border-color: var(--escality-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
  outline: none;
}

/* Form options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.field-checkbox {
  display: flex;
  align-items: center;
}

.field-checkbox .p-checkbox {
  margin-right: 0.5rem;
}

.remember-check {
  color: var(--escality-gray-600);
  font-size: var(--escality-text-base);
  margin-bottom: 0;
  cursor: pointer;
}

.forgot-link {
  color: var(--escality-primary);
  text-decoration: none;
  font-size: var(--escality-text-base);
  font-weight: var(--escality-font-weight-medium);
  transition: color 0.3s ease;
}

.forgot-link:hover {
  color: var(--escality-primary-dark);
  text-decoration: underline;
}

/* Botón de login moderno */
.btn-login-modern.p-button {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, var(--escality-primary) 0%, var(--escality-primary-dark) 100%);
  color: white;
  border: none;
  border-radius: var(--escality-radius-lg);
  font-size: var(--escality-text-md);
  font-weight: var(--escality-font-weight-semibold);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.btn-login-modern.p-button:enabled:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(37, 99, 235, 0.3);
  /* Ambos extremos tenían el mismo color: era un color plano con forma de
     gradiente. Se oscurece un escalón respecto del estado normal
     (primary -> primary-dark), conservando la transición. */
  background: linear-gradient(135deg, var(--escality-primary-hover) 0%, var(--escality-primary-dark) 100%);
}

.btn-login-modern.p-button:enabled:active {
  transform: translateY(0);
}

.btn-login-modern.p-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Loading state for PrimeVue Button */
.btn-login-modern.p-button-loading .p-button-label {
  margin-left: 0.5rem;
}

/* Divider */
.divider {
  text-align: center;
  margin: 2rem 0 1.5rem;
  position: relative;
}

.divider span {
  background: white;
  padding: 0 1rem;
  color: var(--escality-gray-400);
  font-size: var(--escality-text-sm);
  position: relative;
}

.divider::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  background: var(--escality-gray-200);
  z-index: -1;
}

/* Social buttons */
.social-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.social-btn {
  height: 45px;
  border: 2px solid var(--escality-gray-200);
  background: white;
  border-radius: var(--escality-radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: var(--escality-font-weight-medium);
  color: var(--escality-gray-600);
  cursor: not-allowed;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.social-btn:not(:disabled):hover {
  border-color: var(--escality-gray-300);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Register link */
.register-link {
  text-align: center;
  color: var(--escality-gray-600);
  font-size: var(--escality-text-md);
}

.link-primary {
  color: var(--escality-primary);
  font-weight: var(--escality-font-weight-semibold);
  text-decoration: none;
  transition: color 0.3s ease;
}

.link-primary:hover {
  color: var(--escality-primary-dark);
  text-decoration: underline;
}

/* Footer */
.login-footer {
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--escality-gray-200);
  color: var(--escality-gray-500);
  font-size: var(--escality-text-xs);
}

/* Animaciones */
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .login-card {
    padding: 2rem;
    margin: 1rem;
  }
  
  .brand-title {
    font-size: 2rem;
  }
  
  .social-buttons {
    grid-template-columns: 1fr;
  }
}

/* Loading */
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: white;
  font-size: 1.5rem;
}
</style>